import moment from 'moment';

export const stringToColor = (str, { dark = false } = {}) => {
    if (!str) {
        return null;
    }
    let hash = 0;
    str.split('').forEach(char => {
        hash = char.charCodeAt(0) + ((hash << 5) - hash);
    })
    let color = '#'
    for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xff;

        if (dark) {
            value = Math.floor(value * 0.6);
        }

        color += value.toString(16).padStart(2, '0');
    }

    return color + '88';
};

export const countWorkingDays = (startDate, endDate) => {
    const day = moment(startDate);
    let workingDays = 0;

    while (day.isSameOrBefore(endDate, 'day')) {
        if (day.day() !== 0 && day.day() !== 6) {
            workingDays++;
        }
        day.add(1, 'd');
    }
    return workingDays;
};